import { Widget } from "./baseWidget";
import { AvailableOptions } from "./optionsConfig";
import { TextFormatting } from './textFormat'

export class Checkbox extends Widget {
  type = 'checkbox';
  gridX = 12
  minGridX = 3
  config: any = {
    props: [
      'availableOptions',
      'alignment',
      'orientation',
      'csvMode'
    ],
    availableOptions: AvailableOptions,
    orientation: {
      displayName: 'Orientation',
      value: 'horizontal',   //or vertical
      type: 'select',
    },
    csvMode: {
      displayName: 'CSV mode',
      description: 'If enabled, cehckbox will emit user inputs in csv format',
      value: false,
      type: 'boolean',
    },
    alignment: {
      displayName: "Text Alignment",
      value: "flex-start",
      type: 'app-alignment-settings'
    },
  };

  // textFormat = Object.assign({}, textFormatting);
  textFormat;

  constructor(id: number, name: string) {
    super(id, name)
    this.attachCommonConfig(this)

    this.config['title'].value = "Checklist"
    this.config['value']['value'] = []

    //initialize the styles with default values
    this.textFormat = TextFormatting.initStyles(JSON.parse(JSON.stringify(TextFormatting.textFormatting())))
  }

  public getWidgetConfig(){
    let map:any = {
      valuePath: "config.value.value",
      effect: {
        styles: []
      }
    }
    return map;
  }

  public getMappingConfig(){
    let map = {
      __id: "${panel.id}.${widget.id}.value",
      name: "${panel.name} ${widget.name}",
      dataType: "string"
    }
    return map;
  }

  /**
   * to indicate this widget is a selectable widget with options
   */
  public isOptionBasedWidget(){
    return true
  }

  public setOptions(values){
    // console.log("checkbox: setOptions()", this.config, "values", values)
    this.config.value.value = values
    return values;
  }
}
